// Core
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';

// Components
import RequestLogDetailsContent from './components/PosTransactionDetailsContent';

const PosTransactionDetails = () => {
  const { id } = useParams();

  const { data: posTransaction, isLoading, isError } = useQuery({
    queryKey: ['pos-transaction', id],
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchOnError: false,
    queryFn: async () => {
      return (await apiService.getPosTransaction({ id })).data;
    },
  });


  return (isError ?
    <div>Not Found</div> : isLoading ?
    <div>Loading...</div> :
        <RequestLogDetailsContent posTransaction={posTransaction} />
  );
};

export default PosTransactionDetails;